/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export function getStringFromEnv(_) {
    return undefined;
}
export function getBooleanFromEnv(_) {
    return undefined;
}
export function getNumberFromEnv(_) {
    return undefined;
}
export function getStringListFromEnv(_) {
    return undefined;
}
